var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFilledRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2563 3.07007C19.7963 2.74007 19.1963 2.65007 18.6563 2.83007C17.5263 3.20007 16.3863 3.34007 15.2863 3.26007C14.3363 3.18007 13.7163 2.98007 12.9263 2.73007C12.4863 2.59007 12.0063 2.43007 11.4063 2.28007C9.71631 1.85007 7.88631 1.79007 5.95631 2.10007C5.09631 2.24007 4.46631 2.97007 4.46631 3.83007V21.0001C4.46631 21.4101 4.80631 21.7501 5.21631 21.7501C5.62631 21.7501 5.96631 21.4101 5.96631 21.0001V13.4801C7.04631 12.9801 8.13631 12.7201 9.20631 12.7501C10.3163 12.7701 11.0863 13.0401 11.9663 13.3601C12.2963 13.4801 12.6363 13.6001 12.9963 13.7101C14.1063 14.0501 15.2863 14.2201 16.5363 14.2201C17.4963 14.2201 18.5063 14.1201 19.5363 13.9201C20.3663 13.7601 20.9663 13.0301 20.9663 12.2001V4.48007C20.9663 3.91007 20.7063 3.40007 20.2463 3.07007H20.2563Z",
    fill: "var(--color-color11)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFilledRedIcon);
export default __webpack_public_path__ + "static/media/flag-filled-red-icon.43c633096a2b42dc94044794c9c54849.svg";
export { ForwardRef as ReactComponent };